<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="2"
      fill="#da4f64ff"
    />
  </svg>
</template>

<script>
export default { name: 'Square' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
